export default __webpack_public_path__ + "static/media/movies.c8b1089b.PNG";